import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './LandingPage.css'; // Usa o mesmo CSS do form

export default function CancelPage() {
  const { token } = useParams();
  const navigate = useNavigate();

  // Armazena a mensagem de retorno do backend
  const [cancelMessage, setCancelMessage] = useState('');
  // Armazena se foi "success" ou "fail"
  const [wasSuccessful, setWasSuccessful] = useState(false);

  useEffect(() => {
    const cancelPayment = async () => {
      try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/v2/cancel-payment`, { token });
        if (response.data && response.data.success) {
          // Se success = true, guardamos em wasSuccessful
          setWasSuccessful(true);
          if (response.data.message) {
            setCancelMessage(response.data.message);
          }
        } else {
          // se success = false
          setWasSuccessful(false);
          if (response.data && response.data.message) {
            setCancelMessage(response.data.message);
          }
        }
      } catch (err) {
        console.error('Erro ao cancelar pagamento:', err);
        setWasSuccessful(false);
      }
    };

    if (token) {
      cancelPayment();
    } else {
      setCancelMessage('Token inválido ou inexistente.');
      setWasSuccessful(false);
    }
  }, [token]);

  // Ao clicar no "Tente novamente"
  const handleTryAgain = () => {
    // Se deu success, navega para /:token
    if (wasSuccessful) {
      navigate(`/${token}`);
    } else {
      // Senão, vai para "/"
      navigate('/');
    }
  };

  return (
    <div className="pageContainer">
      <div className="messageContainer">
        <h2 className="messageTitle">Pagamento não foi validado</h2>
        <p className="messageText">
          Se achar que isto é um erro, tente novamente mais tarde ou entre em contato.
        </p>

        {/* Exibe a mensagem do back-end ou de erro */}
        {cancelMessage && <p className="messageText">{cancelMessage}</p>}

        {/* Botão "Tente novamente" que decide o destino com base em "wasSuccessful" */}
        <button 
          className="submitButton" 
          onClick={handleTryAgain} 
          style={{ marginTop: '15px' }}
        >
          Tente novamente
        </button>
      </div>
    </div>
  );
}